import { withAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  Box, 
  LinearProgress,
  DialogContent,
  DialogActions,
  DialogContentText,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import makeStyles from "@material-ui/core/styles/makeStyles";
import 'date-fns';
import React, { useEffect, useState } from "react";
import { Loading } from ".";
import { Auth } from 'aws-amplify';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useDispatch } from 'react-redux';
import { getCredits, setCredits } from "../Credit-slice";
import { LoadingEmbed } from "./loading";
import Alert from './snackbar-message';
import generatePassword from "../utils/generate-password";
import getToken from "../utils/get-token";

const DISPLAY_PAGE = 10;

const useStyles = makeStyles((theme) => {
  return {
    container: {
      marginBottom: theme.spacing(2),
    },
  };
});

let interactionTimer = null;

const Patients = withAuth0(({filter}) => {
  const classes = useStyles();
  const [makeRoleRequest, setRoleRequest] = useState(null);
  const [userData, setUserData] = useState([]);
  const [nextToken, setNextToken] = useState('');
  const [noResults, setNoResults] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [pauseLoading, setPauseLoading] = useState(true);
  const [resetSent, setResetSent] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [patientUsername, setPatientUsername] = useState("");
  const [patientPassword, setPatientPassword] = useState(generatePassword());   
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const apiUrl = process.env.REACT_APP_API_URL;
  const userRole = (Auth.user.signInUserSession.idToken.payload["cognito:groups"]).toString();
  const token = getToken();

  const fetchUserData = async (nextToken, searchVal='') => {
    let urlBuilder = new URL(`${apiUrl}/patients`);
    urlBuilder.search = new URLSearchParams({
      nextToken: nextToken ? nextToken : '',
      search: searchVal ? searchVal : ''
    });

    let url = urlBuilder.toString();
    console.log(url)
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": await getToken(),
      },
    })
    
    return response.json();
  }

  const changeSearch = async (event) => {
    setNextToken('');
    setPageIndex(0);
    setUserData([]);
    setNoResults(false);
    setSearchVal(event);
    if(event){
      clearTimeout(interactionTimer);
      setPauseLoading(true);
      interactionTimer = setTimeout(() => {
        setPauseLoading(false);
      }, 500);
    }
  }

  useEffect(() => {
    if(filter == null){
      fetchUserData(nextToken, searchVal).then((result)=> { 
        const {userGroup, token} = result;
        console.log(result);

        setNextToken(token ? token : '');
        if(filter!=undefined)return;
        setUserData(userGroup);
        if(userGroup.length == 0 && pageIndex == 0){
          setNoResults(true);
        }
      });
    }
}, [makeRoleRequest]);

  useEffect(() => {
    setNextToken('');
    setPageIndex(0);
    setUserData([]);
    setNoResults(false);
    setSearchVal(filter);
    setPauseLoading(false);
  }, [filter])

  useEffect(() => {
    if(pauseLoading){
      return;
    }

    if ((pageIndex + 1) >= userData.length / DISPLAY_PAGE && (nextToken !== '' || pageIndex == 0)){
      fetchUserData(nextToken, searchVal).then((result)=> { 
        const {userGroup, token} = result;
        console.log(result)

        setNextToken(token ? token : '');
        setUserData(userData.concat(userGroup));
        if(userGroup.length == 0 && pageIndex == 0){
          setNoResults(true);
        }
      });
    }
  }, [pageIndex, searchVal, pauseLoading]);

  const modifyPageIndex = (isIncrement) => {
    console.log(nextToken);
    if (!isIncrement){
      setPageIndex(pageIndex - 1);
      return;
    } else {
      setPageIndex(pageIndex + 1);
    } 
  }
  
  const fetchCredits = async() =>
    {
      let currentUser = Auth.user.signInUserSession.idToken.payload["cognito:username"];
      const response = await fetch(`${apiUrl}/doctors/${currentUser}/credits`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": await getToken(),
        },
      })
      
      return response.json();
    }

  useEffect(() => {
    fetchCredits().then((result)=> {
      dispatch(setCredits(result.credits))
    }); 
  }, [])

  useEffect(() => {
    if(!makeRoleRequest){
      return;
    }


    const fetchData = async () => {
      let newRole;

      if (makeRoleRequest.role === "Doctor"){
          console.log("set role request: " + makeRoleRequest.role)
          newRole = "Doctor";
        }
      else if (makeRoleRequest.role === "Admin"){
          console.log("set role request: " + makeRoleRequest.role)
          newRole = "Admin";
      }
      else {
        console.log("set role request: " + makeRoleRequest.role)
        newRole = "Manufacturer";
    }

      const response = await fetch(`${apiUrl}/users/${makeRoleRequest.username}/updaterole`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": await getToken(),
        },
        body: JSON.stringify({userGroup: newRole}),
      });
      
      console.log(response);

      setRoleRequest(null);
    }

    fetchData().then(() => {
      changeSearch(null);
    });
  }, [makeRoleRequest]);

  async function deleteAccount(username) {
    const fetchData = async () => {
      const npiResponse = await fetch(`${apiUrl}/users/${username}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": await getToken(),
        },
      })
      //console.log(npiResponse);
      return npiResponse.json();
    }

    fetchData().then((result)=> {
      console.log(result);
      if(result.success){
        let userListItem = userData.find(u => u.username == username);
        console.log(userListItem);
        if(userListItem){
          userListItem.deleted = true;
        }
        setUserData([...userData]);
      }
    });
  };

  async function resetPassword(username, resetPass) {
    setResetSent(false);
    setShowPassword(false);
    setPasswordDialogOpen(false);
    let url = `${apiUrl}/patients/${username}/resetpassword`;
    let alertText = "Patient's password successfully reset";
    let errorText = "Error resetting patients password";

    if(!resetPass) {
      url = `${apiUrl}/patients/${username}/resetpassword?password=${patientPassword}`;
      alertText = "Patient's password successfully set";
      errorText = "Error setting patients password";
    }

    const resetPatientPassword = async () => {
      const npiResponse = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": await getToken(),
        },
      })
      return npiResponse.json();
    }

    resetPatientPassword().then((result)=> {
      console.log(result);
      if(result.success){
        setAlertSeverity("success");
        setAlertText(alertText);
        setResetSent(true);
      }
      else {
        setAlertSeverity("error");
        setAlertText(errorText);
        setResetSent(true);
      }
    });
  };

  const handleClose = () => {
    setPasswordDialogOpen(false);
  };

  const handlePasswordCheck = () => {
    if( patientPassword.length >= 8 ) {
      return true;
    }
    else {
      return false;
    }
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  async function downloadPatients() {
    let rows = [['username', 'created', 'account_status', 'patientName', 'phoneNumber', 'address', 'doctorName', 'doctorNPI']];
    setDownloadProgress(0);
    setDialogOpen(true);
    
    let progress = 0;
    let token = '', userGroup;
    do{
      ({userGroup, token} = await fetchUserData(token));

      progress += userGroup.length;
      setDownloadProgress(progress);

      userGroup.forEach(user => {
        rows.push([user.username, user.created, user.status, user.name, user.phone, (user.address).replace(/,/g, ''), user.doctor, user.doctorNPI]);
      });
    }while(token);

    let link = document.createElement("a");
    let csvContent = "";

    rows.forEach( arr => {
      let row = arr.join(",");
      return csvContent += row + " \r\n";
    });

    let blob = new Blob([csvContent], {type:'text/csv',endings:'transparent'});
    let url = URL.createObjectURL(blob)

    link.setAttribute("href", url);
    link.setAttribute("download", "patient_list.csv");
    link.id = 'download-csv';

    document.body.appendChild(link); // Required for FF
    document.querySelector('#download-csv').click();

    setDialogOpen(false);
  };

  
  const IsolatedMenu = props => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
   
    return(
    <React.Fragment>
      <Button
      variant ="contained"
      aria-label="outlined primary button group"
      aria-controls="simple-menu"
      aria-haspopup="true"
      onClick={event => setAnchorEl(event.currentTarget)}
      >
        <ArrowDropDownIcon />
      </Button>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        onClose={() => setAnchorEl(null)}
      >       
       <MenuItem onClick={() => {
            setAnchorEl(null); 
            window.location.href = `/patientprofile/${props.patient.username}`;
        }}>View Patient Profile</MenuItem>
        <MenuItem onClick={() => {
            setAnchorEl(null); 
            window.location.href = `/prescriptions/${props.patient.username}`;
        }}>View Prescriptions</MenuItem>
        <MenuItem onClick={() => {
            setAnchorEl(null);
            window.location.href = `/sessions/${props.patient.username}`;
        }}>View Sessions</MenuItem>
        {userRole === "Admin" && (<MenuItem onClick={() => {
            setAnchorEl(null);
            setRoleRequest({
              username: props.patient.username,
              role: "Admin"
            })
        }}>Make Admin</MenuItem>)}
        {userRole === "Admin" && (<MenuItem onClick={() => {
            setAnchorEl(null);
            setRoleRequest({
              username: props.patient.username,
              role: "Doctor"
            })
        }}>Make Doctor</MenuItem>)}
        {userRole === "Admin" && (<MenuItem onClick={() => {
            setAnchorEl(null);
            setRoleRequest({
              username: props.patient.username,
              role: "Manufacturer"
            })
        }}>Make Manufacturer</MenuItem>)}
        {userRole === "Admin" && (<MenuItem onClick={() => {
            setAnchorEl(null);
            setPatientPassword(generatePassword());
            setPasswordError(false);
            setPatientUsername(props.patient.username);
            setPasswordDialogOpen(true);
        }}>Manually Set Password</MenuItem>)}
        {userRole === "Admin" && (<MenuItem onClick={() => {
            setAnchorEl(null);
            resetPassword(props.patient.username, true);
        }}>Reset Password</MenuItem>)}
        <MenuItem onClick={() => {
            setAnchorEl(null);
            deleteAccount(props.patient.username);
        }}>Delete Account</MenuItem>
        </Menu>
    </React.Fragment>
    )
  }

  if (makeRoleRequest) {
    return <Loading />;
  }

  let dataSubset = [];
  if (userData){
    dataSubset = userData.slice(pageIndex* DISPLAY_PAGE, (pageIndex*DISPLAY_PAGE) + DISPLAY_PAGE);
  }
  return (
    <>
      <Container className={classes.container}>
        &nbsp;
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <Typography variant="h4">Patients</Typography>
          </Grid>
          <Grid item xs={8}>
            <Grid container justify="flex-end">
              <TextField
                label="Filter Email"
                value={searchVal}
                onChange={event => changeSearch(event.target.value)}
              />
              &nbsp;
              {/* <Button variant="contained" onClick={() => searchUser()}>Search</Button> */}
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5">
              E-mail
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h5">
              Name
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h5">
              Created
            </Typography>
          </Grid>  
          <Grid item xs={2}>
            <Typography variant="h5">
              Status
            </Typography>
          </Grid>
          <Grid item xs={1} style={{textAlign: 'right'}}></Grid>

          {noResults && 
            <Grid item xs={12} style={{textAlign: 'center'}}>
              <Typography variant="h5">
                No results
              </Typography>
            </Grid>
          }
          {!noResults && dataSubset.length == 0 && <Grid item xs={12}><LoadingEmbed/></Grid>}

          {dataSubset && dataSubset.sort((a, b) => a.email - b.email).map(patient => {
            if(patient.deleted){
              return <React.Fragment key={patient.email}>
                <Grid item xs={7}>
                  <Typography variant="body1">
                    [Deleted User]
                  </Typography>
                </Grid>
                <Grid item xs={2}>{patient.created}</Grid>
                <Grid item xs={2}>DELETED</Grid>
              </React.Fragment>;
            }

            return <React.Fragment key={patient.email}>
              <Grid item xs={4}>
                <Typography variant="body1">
                  {patient.email}
                </Typography>
              </Grid>
              <Grid item xs={3}>{patient.name}</Grid>
              <Grid item xs={2}>{patient.created}</Grid>
              <Grid item xs={2}>{patient.status}</Grid>
              
              <Grid item xs={1} style={{textAlign: 'right'}}>
                <IsolatedMenu patient={patient}/>
              </Grid>              
            </React.Fragment>;
          })}
        </Grid>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-end">
          <Grid item>
            <Button onClick={() => modifyPageIndex(false)} disabled={pageIndex === 0}><ArrowBackIosIcon/></Button>
            <Button onClick={() => modifyPageIndex(true)} disabled={nextToken == '' && ((pageIndex + 1)*DISPLAY_PAGE >= userData.length)}><ArrowForwardIosIcon/></Button>
          </Grid>
        </Grid>       
        <Grid container justify='center' xs={12}>
          <Button
            variant ="contained"
            aria-haspopup="true"
            onClick={() => downloadPatients()}
          >
            Download Patient List
          </Button>
        </Grid> 
        <Dialog open={dialogOpen}>
          <DialogTitle> Downloading Patient Info </DialogTitle>
          <DialogContent style={{textAlign: 'center'}}>
            <Box m={2}><LinearProgress/></Box>
            {downloadProgress} records fetched...
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {setDialogOpen(false)}}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={passwordDialogOpen} onClose={handleClose}>
          <DialogTitle>Set Patient Password</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Use the auto-generated password below, or enter the password you would like to use for this patient.
              Upon confirmation, the patient's password will be set and they will be notified via email.
            </DialogContentText>
            <TextField
              autoFocus
              margin="normal"
              id="patientpassword"
              label="Password"
              variant="standard"
              type={showPassword ? 'text' : 'password'}
              value = {patientPassword}
              error={passwordError}
              onChange={(e) => setPatientPassword(e.target.value)}
              helperText="Must be at least 8 characters"
              required
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick = {() =>{
                let validPassword = handlePasswordCheck();
                if(validPassword) {
                  resetPassword(patientUsername, false);
                }
                else{
                  setPasswordError(true);
                }
                }}
                >Set Password
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        {resetSent && <Alert children={alertText} severity={alertSeverity}/>}
      </Container>
    </>
  );
});

export default Patients;